import { createContext, useContext, ReactNode } from 'react';
import { ActivityStatus } from '~/types/interfaces/activity';

interface ActivityStatusModalContextType {
  openModal: (activityId: string, newStatus: ActivityStatus) => void;
  closeModal: () => void;
}

const ActivityStatusModalContext = createContext<
  ActivityStatusModalContextType | undefined
>(undefined);

export const useActivityStatusModal = () => {
  const context = useContext(ActivityStatusModalContext);
  if (!context) {
    throw new Error(
      'useActivityStatusModal must be used within ActivityStatusModalProvider',
    );
  }
  return context;
};

interface ActivityStatusModalProviderProps {
  children: ReactNode;
  openModal: (activityId: string, newStatus: ActivityStatus) => void;
  closeModal: () => void;
}

export const ActivityStatusModalProvider = ({
  children,
  openModal,
  closeModal,
}: ActivityStatusModalProviderProps) => {
  return (
    <ActivityStatusModalContext.Provider value={{ openModal, closeModal }}>
      {children}
    </ActivityStatusModalContext.Provider>
  );
};
